import Button from '@material-ui/core/Button';
import { theme as picardyTheme } from '@picardy/picardy-design-system';

import { styled } from '@material-ui/styles';

export const FullWidthMobileButton = styled(Button)(
  ({ theme }: { theme: typeof picardyTheme }) => ({
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  }),
);
